import { AutoComplete, Input } from 'antd';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import IInvestor from '~Api/Investor/IInvestor';
import history from '~history';
import {
    investorsSearchAction,
    investorsSearchResultsClearAction,
} from '~Investors/actions';
import { IGlobalState } from '~reducer';
import { IDictionary } from '~utilities/IDictionary';
import { investorsSearchResultsSelector } from './selectors';

interface IOption {
    label: JSX.Element;
    value: string;
}

interface IState {
    searchText: string;
}

interface IPropsSelector {
    investorsSearchResults: IDictionary<IInvestor>;
}

interface IPropsDispatch {
    investorsSearchResultsClear: () => void;
    investorsSearch: (keyword: string) => void;
}

type Props = IPropsSelector & IPropsDispatch;

class Search extends React.Component<Props, IState> {
    public state: IState = {
        searchText: '',
    };

    constructor(props: Props) {
        super(props);

        this.onSearch = this.onSearch.bind(this);
        this.onSelect = this.onSelect.bind(this);
    }

    public componentDidMount(): void {
        this.props.investorsSearchResultsClear();
    }

    public render(): JSX.Element {
        const { investorsSearchResults } = this.props;

        const options: IOption[] = investorsSearchResults && _.map(investorsSearchResults, (investor: IInvestor) => {
            const label: JSX.Element = (
                <div className='investor-search-option'>
                    <div className='name'>{investor.name}</div>
                </div>
            );

            return {
                label,
                value: `${investor.uuid}`,
            };
        });

        return (
            <AutoComplete
                dropdownMatchSelectWidth={300}
                onSearch={this.onSearch}
                onSelect={this.onSelect}
                options={_.slice(options, 0, 20)}
                popupClassName='investors-search-dropdown'
                value={this.state.searchText}
            >
                <Input.Search/>
            </AutoComplete>
        );
    }

    private onSearch(value: string): void {
        this.setState({
            searchText: value,
        });

        this.props.investorsSearch(value);
    }

    private onSelect(value: string): void {
        this.props.investorsSearchResultsClear();

        history.push(`/investors/${value}`);
    }
}

function mapStateToProps(state: IGlobalState): IPropsSelector {
    return {
        investorsSearchResults: investorsSearchResultsSelector(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch): IPropsDispatch {
    return {
        investorsSearch: (keyword) => dispatch(investorsSearchAction(keyword)),
        investorsSearchResultsClear: () => dispatch(investorsSearchResultsClearAction()),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Search);
